// CD4011: if DE 4/1 Delivery terms is used, exactly one of these combinations must be filled in:
// - coded: INCOTERM code + UN/LOCODE
// - free text: INCOTERM code + country code + location name

type DeliveryTerms = {
    incotermCode?: string | null;
    unlocode?: string | null;
    countryCode?: string | null;
    place?: string | null;
};

export type DeliveryTermsError = {
    field: 'unlocode' | 'countryCode' | 'place';
    message: string;
};

const LOCATION_MISSING_MESSAGE = 'Provide UN/LOCODE, or country and location name';
const BOTH_FORMS_MESSAGE = 'Provide either UN/LOCODE, or country and location name - not both';
const COUNTRY_MISSING_MESSAGE = 'Country is required when a location name is given';
const PLACE_MISSING_MESSAGE = 'Location name is required when a country is given';

const isFilled = (value?: string | null) => !!value?.trim();

export const getDeliveryTermsErrors = (
    terms: DeliveryTerms,
    { isTemplate = false }: { isTemplate?: boolean } = {}
): DeliveryTermsError[] => {
    const hasIncoterm = isFilled(terms.incotermCode);
    if (!hasIncoterm) return [];

    const hasUnlocode = isFilled(terms.unlocode);
    const hasCountry = isFilled(terms.countryCode);
    const hasPlace = isFilled(terms.place);
    const startedFreeText = hasCountry || hasPlace;

    if (hasUnlocode && startedFreeText) {
        return [{ field: 'unlocode', message: BOTH_FORMS_MESSAGE }];
    }

    if (hasUnlocode) return [];

    // A template only applies part of a declaration, so it need not name a location.
    if (isTemplate) return [];

    if (!startedFreeText) {
        return [
            { field: 'countryCode', message: LOCATION_MISSING_MESSAGE },
            { field: 'place', message: LOCATION_MISSING_MESSAGE },
        ];
    }

    const errors: DeliveryTermsError[] = [];
    if (!hasCountry) errors.push({ field: 'countryCode', message: COUNTRY_MISSING_MESSAGE });
    if (!hasPlace) errors.push({ field: 'place', message: PLACE_MISSING_MESSAGE });
    return errors;
};
